<template>
  <div class="content-list">
    <div v-for="(item, index) in content" :key="index" class="content-item">
      <div class="title-container">
        <img src="@/assets/images/icons/error-label-icon.svg" alt="error-label" class="icon" />
        <span class="content-title">{{ getTitle(item.value) }}</span>
      </div>
      <p class="content-description">{{ item.label }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  content: {
    type: Array,
    required: true,
  },
});

const getTitle = (value) => {
  const titleMap = {
    CATEGORY_ERROR: "Hatalı Eşleşen Kategori",
    PRICE_ERROR: "Hatalı Fiyat Şüphesi",
    MATCHED_PRODUCT: "Katalogda Eşleşen Ürün",
    MATCHED_SIMILARITY: "Katalogta Eşleşen Benzer Ürün",
    MATCH_PENDING: "Eşleşme Bekleyen Ürün",
    CBT_PRICE_ERROR: "Gümrük Mevzuatı Sınırlaması",
    UNUSUAL_ORDER_ACTIVITY: "Olağandışı Satış Hacmi Tespiti",
  };
  return titleMap[value] || value;
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.content-list {
  display: flex;
  flex-direction: column;
}

.content-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
}

.title-container {
  display: flex;
  align-items: center;
}

.icon {
  width: 11.667px;
  height: 11.667px;
  margin-right: 4px;
}

.content-title {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: $colorE60;
}

.content-description {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: $colorN80;
}
</style>
